// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"25da2d79","272":"d875f2a0","403":"091b9c00","453":"ad1281f2"}[chunkId] + ".chunk.js";
};